<template>
  <div>
    <!-- 头部start -->
    <crumbs :activeIndex="2"></crumbs>
    <!-- 头部 end-->
    <!-- 广告start -->
    <div class="y-advertisement">
      <img src="../../static/img/belong.png" alt />
    </div>
    <!-- 广告end -->
    <!-- 导航start -->
    <div class="y-navigation">
      <div class="min y-navigation-box">
        <div class="router-active">
          <img src="../../static/img/icon.png" alt />
          <router-link to="/">首页 ></router-link>展项预览>
          <!-- {{hallList[index].Name}} -->
          <span style="color:#0078FF">{{Name}}</span>
        </div>
        <div class="y-navigation-select">
          <ul>
            <li
              v-for=" (item,index) in hallList"
              :key="index"
              :class="{active:index==activeIndex}"
              @click="selectFun(index,item)"
            >{{item.Name}}</li>
          </ul>
        </div>
      </div>
    </div>
     <!-- 二级 区域 itemList -->
     <div>

     </div>
    <!-- 导航end -->
    <div class="showmore">
      <div class="navigationselect">
        <ul>
          <li
            v-for=" (item,index) in itemList"
            :key="index"
            :class="{activeItem: index==activeItemIndex}"
            @click="changeItemFun(index,item)"
          >{{item.Name}}</li>
        </ul>
      </div>
      <div class="showmoreCenter">
        <div class="showmoreCenterdf">
          <div class="showmoreCenterdfImg" @click="changeImgFun(baseURL + gearedLists.PicWap)">
           <img :src="baseURL + gearedLists.PicWap" alt="">
          </div>
          <div class="showmoreCenterdfright">
            <h4>{{gearedLists.Title}}</h4>
            <div class="organization-text" v-html="gearedLists.Description "></div>
          </div>
        </div>
          <!-- 剧场展示start -->
        <div class="paradise-display-min">
          <div class="paradise-item">
              <div
                class="paradise-display-item"
                v-for="geared in gearedList"
                :key="geared.id"
              >
              <span v-if="geared.Subtitle!==null">{{geared.Subtitle}}</span>
                <img :src="baseURL+geared.Pic" alt />
                <router-link
                  :to="{ path:'/details',query:{ id:geared.Id,activeIndex:activeIndex,coolId:coolId}}"
                  tag="span"
                >
                  <p>{{geared.Title}}</p>
                </router-link>
              </div>
          </div>
          <!-- 剧场展示end -->
        </div>
      </div>
    </div>
    <tab></tab>
    <!-- 友情链接start -->
    <!-- 友情链接end -->
    <Footer></Footer>
    <popupimg ref="popupimg" />
  </div>
</template>

<script>
import tab from "@/components/tab.vue";
import popupimg from '@/components/popupImg.vue'
export default {
  components: {   tab , popupimg},
  data() {
    return {
      hallList: [],
      activeIndex: 0,
      activeItemIndex: 0,
      gearedList: [],
      baseURL:window.SITE_CONFIG.baseUrl+'/yxht',
      venueList: [],
      itemList: [], // 展厅区域
      leftImg: "", // 左边图片
      gearedLists: {},
      Name: "一层场馆",
      id: "",
      coolId: ""
    };
  },

  mounted() {
    console.log(this.$route.query, 811);
    if (!this.$route.query.index == "") {
      this.activeIndex = this.$route.query.index/1;
      let id = this.$route.query.id;
      console.log(id, 933);
      this.hallListFun(this.activeIndex);
    }  else{
       this.hallListFun(0);
    }
  },
  methods: {
    // 获取 展馆
    hallListFun(index) {
      this.$http
        .get("/yxht//Categories/GetList", {
          ParentId: "424bcc2b-4fbf-4a89-9579-0f442bc54010",
          Type: 2,
          rows: 100,
          page: 1
        })
        .then(res => {
          this.hallList = res.data.rows; //热门展项
          // this.gearedFun(this.hallList[0].id);
          this.selectFun( index, this.hallList[index])
        });
    },
    // 一层展馆  切换
    selectFun(index, item) {
      this.Name = item.Name;
      this.id = item.Id;
      this.getItemListFun(item.Id);
      this.getLeftImg(item.Id);
      this.activeIndex = index;
    },
    // 获取 左边图片
    getLeftImg(id){
       this.$http
        .get("yxapi//api/News/GetNewsList", {
          CategoryId: id,
          page: 1,
          size: 100
        })
        .then(res => {
          let geared = JSON.parse(res.data.Result).rows;
          this.leftImg = geared[0].Pic
          console.log('this.PicWap)',  geared)
        });
    },
    // 封面图预览
    changeImgFun(e) {
      this.$refs.popupimg.handle(e)
    },
    // 获取展馆下面的 展厅
    getItemListFun(id) {
      this.$http
        .get("/yxht//Categories/GetList", {
          ParentId: id,
          Type: 2,
          rows: 15,
          page: 1
        })
        .then(res => {
          if(res.data.rows){
            this.itemList = res.data.rows; // 展区域
             this.changeItemFun(0, res.data.rows[0])
          }
        });
    },
    // 点击 二级 选择区域
    changeItemFun(index, item) {
      this.activeItemIndex = index;
      this.gearedFun(item.Id);
    },
    // 展馆详情
    gearedFun(id) {
      this.$http
        .get("yxapi//api/News/GetNewsList", {
          CategoryId: id,
          page: 1,
          size: 100
        })
        .then(res => {
          console.log('JSON.parse(res.data.Result)',JSON.parse(res.data.Result))
          let geared = JSON.parse(res.data.Result).rows;
          if(geared.length>0){
              this.gearedLists = geared.shift(); //
               console.log( 909090909,this.gearedLists )
              this.gearedLists.Description = this.gearedLists.Description.replace(
              /\<img src="/gi,
             '<img style="margin:0 auto" src="http://www.sxszstm.com'
            );
            this.gearedList = geared;
            console.log('this.gearedLis)',  geared)
          }else{
             this.gearedLists = {}
             this.gearedList = []
          }
        });
    },
  }
};
</script>

<style  scoped>
.showmore{
  width: 1200px;
  margin: 0 auto;
}
.showmoreCenterdf{
  display: flex;
}
.showmoreCenterdfImg{
  width: 300px;
  height: 200px;
  display: inline-block;
  padding-top: 0%;
  text-align: center;
  position: relative;
  display: block;
  overflow: hidden;
  border: 1px solid rgb(243, 243, 243);
  border-radius: 10px;
  margin-right: 20px;
}
.showmoreCenterdfImg img{
    transition: all 0.5s;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: auto;
    max-height: 100%!important;
    max-width: 100%;
    margin: auto!important;
    vertical-align: middle;
    box-sizing: border-box;
}
.showmoreCenterdfright{
   flex: 1;
}
.showmoreCenterdfright h4{
  padding-top: 10px;
  padding-bottom: 20px;
}
.navigationselect{
  display: inline-block;
  width: 100%;
}
.navigationselect ul{
  font-size: 18px;
  height: 80px;
  line-height: 70px;
  display: flex;
  float: left;

}
.navigationselect ul li{
  padding-right: 20px;
}
.activeItem{
  color: #0078ff;
  font-weight: bold;
}
.service-gray-content {
  margin-bottom: 60px;
}
.is-animating {
  display: flex;
}
.router-active {
  display: flex;
  align-items: center;
  height: 60px;
}
.router-active img {
  width: 17px;
  height: 20px;
  margin-right: 6px;
}
.router-link-active {
  color: #000000;
}
.y-advertisement {
  width: 100%;
  height: 340px;
}
.y-advertisement img {
  width: 100%;
  height: 340px;
  background-size: 340px 100%;
}
.explain-item img {
  width: 100%;
  height: 100%;
}
.show-more .el-carousel--horizontal {
  /* height: 999px; */
  overflow-x: none !important;
}
.paradise-display-min {
  width: 1200px;
  margin: 0 auto;
  margin: 60px 0;
  display: inline-block;
}
.paradise-item {
  width: 100%;
  position: relative;
}
.el-carousel__container {
  display: flex;
  justify-content: flex-start;
}
.paradise-display-item {
  position: relative;
  width: 270px;
  margin: 30px 30px 0 0;
  float: left;

}
.paradise-display-item span:nth-child(1){
 width: 30px;
 height: 30px;
 background: #ff002b;
 position: absolute;
 top: 0;
 /* right: 0; */
 font-size: 12px;
 line-height: 30px;
 text-align: center;
 color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/view/preview.vue